







































































import {Component, Inject, Watch} from "vue-property-decorator";
import PersonMarker from "../PersonMarker.vue";
import UserCard from "../user-card/UserCard.vue";
import Api from "./Api";
import {
    CardUserdata,
    GuiUserlisting, PersonMergeResult,
} from "../../modules/models";
import {Route} from "vue-router";
import {firstOne} from "../../modules/utils";
import rd from "../../modules/vRoutedefs";
import CompanyUserRequired from "../CompanyRequired";

@Component({
    components: {
        "at-person-marker": PersonMarker,
        "at-user-card": UserCard
    }
})
export default class UserAdmin extends CompanyUserRequired {
    @Inject()
    api!: Api;

    get isAdmin() {
        return this.user.isCompanyAdmin(this.company.orgNum) || this.user.isCompanySuper(this.company.orgNum);
    }

    searchTxt = "";
    pageNum = 1;
    personListLoading = false;
    personList: GuiUserlisting[] = [];

    personData: CardUserdata | null = null;
    personDataGuid: string | null = null;
    personDataLoading = false;

    async loadPersonList() {
        this.personListLoading = true;
        this.personList = await this.api.userList(this.searchTxt, this.pageNum);
        this.personListLoading = false;
    }

    showRoleRemoved = false;
    async onRoleRemoved() {
        await this.refreshPersonData();
        this.showRoleRemoved = true;
    }

    async loadPersonData(personRef: string) {
        try {
            this.personDataGuid = personRef;
            this.personDataLoading = true;
            this.personData = await this.api.userData(this.personDataGuid);
        } catch(e) {
            this.emitError(e);
        } finally {
            this.personDataLoading = false;
        }
    }

    async refreshPersonData() {
        if(this.personDataGuid != null) {
            // XXX perhaps do something else here later to avoid disturbing reload animation
            await this.loadPersonData(this.personDataGuid)
        }
    }

    // called when UserEdit emits at-user-edit-saved
    onUserEdited(d) {
        // reload views to display edit changes
        this.refreshPersonData();
        this.loadPersonList();
    }

    showRoleAdded = false;
    // called when role has been added to user
    async onRoleAdded() {
        await this.refreshPersonData();
        this.showRoleAdded = true;
    }

    showMergeUndone = false;
    onUserUnmerged(d) {
        this.showMergeUndone = true;
        this.refreshPersonData();
        this.loadPersonList();
    }

    onUserMerged(d) {
        const result: PersonMergeResult = d;
        if(result.txid > 0 && result.fromPersonRef === this.personDataGuid) {
            // The currently displayed person was the from person in merge, show toPerson instead
            this.$router.replace(this.userGuidTo(result.toPersonRef));
        } else {
            this.refreshPersonData();
        }
        this.loadPersonList();
    }

    get userAddTo() {
        return { name: rd.users.add.name };
    }

    userGuidTo(personGuid: string) {
        return {query: {guid: personGuid}};
    }

    @Watch("$route", {immediate: true})
    onRouteChanged(newRoute: Route, oldRoute: Route) {
        if(newRoute === undefined) {
            this.personData = null; // Don't display any person
        } else if(oldRoute === undefined || newRoute.query != oldRoute.query) {
            const guid = firstOne(newRoute.query["guid"]);
            if(guid) {
                this.loadPersonData(guid);
            } else {
                this.personData = null; // No valid guid to display
            }
        }
    }

    // hook
    created() {
        this.loadPersonList();
    }

  get reportsUserTo() {
    return {path: rd.users.reports.allusers.path}
  }
}
